/* @flow */

export default class SalesPersonPhoneNumber {
  countryId: number;
  number: string;
}
